import PayDiscrepancyLayout from "@/app/(app)/(crew)/reports/(pay-discrepancy)/_layout";

export default PayDiscrepancyLayout;
